module.exports = __webpack_public_path__ + "static/media/add_information_ja.abd8bc5e.gif";